import { __assign, __awaiter, __generator } from "tslib";
import { createWebNotificationsApi } from './web-notifications';
import { createPhoneApi } from './phone';
import { createArticlesApi } from './articles/';
import { createCallcenterApi } from './callcenter/';
import { createTicketsApi } from './tickets';
import { createUsersApi } from './users';
import { createSettingsApi } from './settings';
import { createAccountApi } from './account';
import { createFilesApi } from './files';
import { createAdminApi } from './admin';
import { createTenantsApi } from './tenants';
import { createLabelsApi } from './labels';
import { createWidgetApi } from './widget';
import { createKbApi } from './kb';
import { createTeamApi } from './team';
import { createInsightsApi, createChatInsightsApi } from './insights';
import { createTeamPerformanceInsightsApi, createMyStatisticsInsightsApi } from './insights/team-performance';
import { createChatApi } from './chat';
import { createIntegrationsApi } from './integrations';
import { getAccessToken } from './get-access-token';
import { addDefaultHeaders } from './http/utils';
import { createSlaApi } from './sla';
import { createUserStorageApi } from './user-storage';
import { createCompaniesApi } from './company';
import { createMacrosApi } from './macros';
import { createUserRolesApi } from './roles';
import { createWhatsappApi } from './whatsapp';
import { createChatDashboardApi, createControlRoomApi, createEmailDashboardApi, createOmnichannelDashboardApi } from './control-room';
import { createAgentAutoRoutingApi } from './agent-auto-routing';
import { createWorkflowsApi } from './workflows';
import { createSmsApi } from './sms';
import { createBrandsApi } from './brands';
import { createSchedulesApi } from './schedules';
import { createWasabiApi } from './wasabi';
import { createTwitterApi } from './twitter';
import { createInstagramApi } from './instagram';
import { createSkillsApi } from './skills';
export * from './account';
export * from './admin';
export * from './agent-auto-routing';
export * from './app-navigator';
export * from './articles';
export * from './brands';
export * from './callcenter';
export * from './chat';
export * from './company';
export * from './control-room';
export * from './custom-fields';
export * from './domain';
export * from './files';
export * from './http';
export * from './insights';
export * from './integrations';
export * from './kb';
export * from './labels';
export * from './macros/';
export * from './phone/';
export * from './roles/';
export * from './settings/';
export * from './sla';
export * from './sms';
export * from './team';
export * from './tenants';
export * from './test-utils';
export * from './testkit';
export * from './tickets/';
export * from './user-storage';
export * from './users';
export * from './web-notifications';
export * from './whatsapp';
export * from './widget';
export * from './workflows';
export * from './schedules';
export * from './wasabi';
export * from './twitter';
export * from './instagram';
export * from './skills';
export var EXPIRED_SESSION = 401;
export var NO_ACTION_PERMISSION = 403;
export var createAnswersApi = function (params) {
    var baseUrl = params.baseUrl, http = params.http, clientName = params.clientName, credentials = params.credentials, errorsHandler = params.errorsHandler;
    var headersFetcher = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!credentials) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAccessToken(credentials, http, baseUrl)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = '';
                    _b.label = 3;
                case 3:
                    token = _a;
                    return [2 /*return*/, __assign({ 'X-Ans-Client': clientName }, (token ? { Authorization: "Bearer " + token } : {}))];
            }
        });
    }); };
    var wrappedHttp = addDefaultHeaders(http, headersFetcher, errorsHandler);
    return {
        account: createAccountApi(baseUrl, wrappedHttp),
        admin: createAdminApi(baseUrl, wrappedHttp),
        articles: createArticlesApi(baseUrl, wrappedHttp),
        brands: createBrandsApi(baseUrl, wrappedHttp),
        callcenter: createCallcenterApi(baseUrl, wrappedHttp),
        chat: createChatApi(baseUrl, wrappedHttp),
        companies: createCompaniesApi(baseUrl, wrappedHttp),
        files: createFilesApi(baseUrl, wrappedHttp),
        insights: createInsightsApi(baseUrl, wrappedHttp),
        integrations: createIntegrationsApi(baseUrl, wrappedHttp),
        kb: createKbApi(baseUrl, wrappedHttp),
        labels: createLabelsApi(baseUrl, wrappedHttp),
        macros: createMacrosApi(baseUrl, wrappedHttp),
        userRoles: createUserRolesApi(baseUrl, wrappedHttp),
        myStatistics: createMyStatisticsInsightsApi(baseUrl, wrappedHttp),
        phone: createPhoneApi(baseUrl, wrappedHttp),
        settings: createSettingsApi(baseUrl, wrappedHttp),
        sla: createSlaApi(baseUrl, wrappedHttp),
        team: createTeamApi(baseUrl, wrappedHttp),
        teamPerformance: createTeamPerformanceInsightsApi(baseUrl, wrappedHttp),
        chatInsights: createChatInsightsApi(baseUrl, wrappedHttp),
        tenants: createTenantsApi(baseUrl, wrappedHttp),
        tickets: createTicketsApi(baseUrl, wrappedHttp),
        userStorage: createUserStorageApi(baseUrl, wrappedHttp),
        users: createUsersApi(baseUrl, wrappedHttp),
        whatsapp: createWhatsappApi(baseUrl, wrappedHttp),
        sms: createSmsApi(baseUrl, wrappedHttp),
        webNotifications: createWebNotificationsApi(baseUrl, wrappedHttp),
        widget: createWidgetApi(baseUrl, wrappedHttp),
        controlRoom: createControlRoomApi(baseUrl, wrappedHttp),
        chatdashboard: createChatDashboardApi(baseUrl, wrappedHttp),
        agentAutoRouting: createAgentAutoRoutingApi(baseUrl, wrappedHttp),
        workflows: createWorkflowsApi(baseUrl, wrappedHttp),
        schedules: createSchedulesApi(baseUrl, wrappedHttp),
        wasabi: createWasabiApi(wrappedHttp),
        twitter: createTwitterApi(baseUrl, wrappedHttp),
        instagram: createInstagramApi(baseUrl, wrappedHttp),
        emailDashboard: createEmailDashboardApi(baseUrl, wrappedHttp),
        omnichannelDashboard: createOmnichannelDashboardApi(baseUrl, wrappedHttp),
        skills: createSkillsApi(baseUrl, wrappedHttp),
    };
};
//# sourceMappingURL=index.js.map